import React from 'react';
import dayjs from 'dayjs';

import { weeklyPlannerDayDisplayFormat } from '~libs/dayjs';

import { buildColumn, EditableColumnConfig } from '~components/table-view';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

const getAwardAlertsColumns = () => {
  const columnsList: EditableColumnConfig[] = [
    {
      id: 'date',
      header: 'Day',
      type: 'custom',
      style: {
        cell: 'ml-2',
      },
      props: {
        meta: {
          renderCustom: (_: never, row: any) => {
            if (!row) return null;
            const date = row.original?.date || row.date;
            const displayDate = date ? dayjs(date).format(weeklyPlannerDayDisplayFormat) : '-';
            return React.createElement('span', {}, displayDate);
          },
        },
      },
    },
    {
      id: 'user.full_name',
      header: 'Worker',
      type: 'text',
    },
    {
      id: 'message',
      header: 'Alert',
      type: 'text',
    },
    {
      id: 'actions',
      header: '',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_: never, row: any) => {
            if (!row) return null;
            const userId = row.original?.user?.id ?? row.user?.id;
            return React.createElement(WorkerFocusAction, {
              userId,
            });
          },
        },
      },
    },
  ];

  return columnsList.map(buildColumn);
};

export default getAwardAlertsColumns;
